import Configuration from '../configuration';
import { $httpProvider } from '../providers';

function getChainesLocales(adresseInsee, codeInsee) {
  return $httpProvider()({
    method: 'GET',
    url: Configuration.getChainesLocales,
    urlConfig: {
      pathParams: {
        codeinsee: codeInsee,
        adresse: adresseInsee
      }
    }
  }).then(r => r.data);
}

export default {
  getChainesLocales
};



// WEBPACK FOOTER //
// ./src/repositories/chaines-locales.repository.js